import { createFileRoute } from "@tanstack/react-router";
import { usersListSearchSchema } from "@/features/admin/users/_configs/users-list-search-schema";
import { UsersList } from "@/features/admin/users/list";

export const Route = createFileRoute("/admin/users/")({
  validateSearch: usersListSearchSchema,
  component: UsersList,
});
